module.exports = __webpack_public_path__ + "img/modelMarket4.73fe5f87.png";